<template lang="pug">
  .units-management
    .course-units(rounded)
      .d-flex
        .title Структура курса
        v-spacer
        v-btn(
          v-if="canCreateUnit"
          color="secondary"
          rounded
          depressed
          @click="createUnit"
        )
          v-icon mdi-plus
          span.ml-2.d-none.d-sm-block Создать тему

      v-scroll-y-reverse-transition(leave-absolute)
        v-skeleton-loader(
          v-if="loading.units"
          type="list-item@3"
        )
        div(v-else)
          lazy-load(
            v-model="loadMoreUnits"
            @on-response="({ items }) => units.push(...serializeUnits(items))"
          )
            unit-management-draggable(
              v-model="units"
              :course="course"
              :editable="editable"
              :can-delete-unit="canDeleteUnit"
              @change-unit-order="unitOrderChanged"
              @change-lesson-order="lessonOrderChanged"
              @deleted="onDelete"
            ).mt-4
          v-row.ma-0.pa-0.justify-center
            v-btn.align-center(
              v-if="pagination.page < pagination.length"
              color="primary"
              @click="pagination.page += 1"
            ) Загрузить еще ..
          p.grey--text(v-if="!units.length") Пока нет ни одной темы...
</template>

<script>
import Vue from 'vue';
import { VExpansionPanels } from 'vuetify/lib';

import UnitForm from '@/components/Forms/UnitForm.vue';

import UnitManagementDraggable from './UnitManagementDraggable.vue';

// Явная регистрация компонента нужна, т.к. без нее vuedraggable не видит vuetify компонентов
Vue.component('VExpansionPanels', VExpansionPanels);

export default {
  name: 'UnitManagement',
  components: {
    UnitManagementDraggable,
  },
  props: {
    course: { type: Object, default: null },
    moduleItem: { type: Object, default: null },

    // Get units method
    method: { type: Function, required: true },
    editable: { type: Boolean, default: true },
    canCreateUnit: { type: Boolean, default: true },
    canDeleteUnit: { type: Boolean, default: true },
  },
  data: () => ({
    units: [],
    loadMoreUnits: null,

    pagination: {
      page: 1,
      length: null,
    },
    overlay: false,

    showUnitCreateDialog: false,
    changeOrderEnable: false,
    oldCourseUnitsOrder: [],
    newCourseUnitsOrder: [],
    loading: {
      units: true,
      changeOrderButton: false,
      changeOrderButtonCheck: false,
    },
  }),
  watch: {
    'pagination.page': {
      handler() {
        this.fetchUnits();
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.loading.units = true;
      await this.fetchUnits();
      this.loading.units = false;
    },
    fetchUnits() {
      return this.method()
        .then(({ items, loadMore }) => {
          this.loadMoreUnits = loadMore;
          this.units = this.serializeUnits(items);
          return items;
        });
    },
    serializeUnits(items) {
      return items.reduce((acc, unit) => {
        let item = unit;
        if (item.moduleItem) {
          if (acc.find((i) => i.moduleItem?.id === item.moduleItem.id)) return acc;
          item = {
            moduleItem: item.moduleItem,
            units: items.filter((i) => i.moduleItem?.id === item.moduleItem.id),
          };
        }
        return [...acc, item];
      }, []);
    },
    async loadTasks(courseUnit) {
      courseUnit.fetchLessons();
    },
    unitOrderChanged(val) {
      if (val.moved) {
        const { element } = val.moved;
        let successMessage = `Тема "${element.title}" перемещена`;
        if (element.moduleItem) successMessage = `Модуль "${element.moduleItem.name}" перемещен`;
        this.sendChangedUnitsOrder(successMessage);
      }
    },
    lessonOrderChanged(val) {
      if (val.added || val.moved) {
        const name = val.added ? val.added.element.name : val.moved.element.name;
        this.sendChangedUnitsOrder(`Урок "${name}" перемещен`);
      }
    },
    async sendChangedUnitsOrder(successMessage) {
      const preparedItems = this.units
        .reduce((acc, unit) => {
          if (unit.moduleItem) return [...acc, ...unit.units];
          return [...acc, unit];
        }, [])
        .map((i) => (
          { id: i.id, lessons: i.lessons.map((l) => (l.id)) }
        ));

      let promise = null;
      if (this.course) {
        promise = () => this.$api.courses.changeCourseUnitsOrder(this.course.id, preparedItems);
      }
      if (this.moduleItem) {
        promise = () => this.$api.modules.sort(this.moduleItem.id, preparedItems);
      }

      await promise().catch(() => this.$toasted.error('Ошибка при изменении порядка тем', { duration: 3000 }));
      this.$toasted.success(successMessage, { duration: 3000 });
    },
    onDelete(item) {
      this.units = this.units.filter((i) => i !== item);

      if (item.moduleItem) this.$emit('removed:module', item);
      else this.$emit('removed:unit', item);
    },
    createUnit() {
      this.$modals.show('generic-controller', {
        title: 'Создать тему',
        component: UnitForm,
        'component-props': {
          order: this.units.length,
          'module-id': this.moduleItem?.id,
          'course-id': this.course?.id,
          successCallback: (resp) => {
            this.units.push(resp.data.data);
            this.$modals.close();
          },
        },
      });
    },
  },
};
</script>
